











































import {Component, Vue, Prop} from 'vue-property-decorator'
import {Task} from '@/store/types'
import DateFormatter from '@/classes/DateFormatter'
import SurveyModel from '@/classes/SurveyModel'

@Component({})
export default class SurveyListItem extends Vue {
  @Prop(Object) public task!: Task

  public SurveyModel = SurveyModel

  private get dateFormatted() {
    const dateFormatter = new DateFormatter()
    if (this.task && this.task.status === SurveyModel.STATUS.CANCELED) {
      return dateFormatter.setFormat('MMMM D, YYYY').get(this.task.canceled_at)
    } else if (this.task && this.task.status === SurveyModel.STATUS.COMPLETED) {
      return dateFormatter.setFormat('MMMM D, YYYY').get(this.task.completed_at)
    } else {
      return dateFormatter.setFormat('dddd ha').get(this.task.date + ' ' + this.task.time)
    }
  }

  public statusColor(task: Task) {
    if (task.status === SurveyModel.STATUS.CANCELED || task.date === null || task.time === null) {
      return 'is-danger'
    } else if (task.status === SurveyModel.STATUS.PENDING) {
      return 'is-secondary'
    } else if (task.status === SurveyModel.STATUS.COMPLETED) {
      return 'is-success'
    } else {
      return 'is-primary'
    }
  }
}
